<div class="page row">
  <!-- Filtro sidebar -->
  <div class="col-lg-3" *ngIf="FilterViewType == 'sidebar' && openFilter"
    style="transition: 0.2s ease-in; background-color: white;">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Filtri</h5>
        <app-field-viewer [(Campi)]="CrudSettings.Filters" [(Oggetto)]="filtro"
          (OnChange)="Refresh()"></app-field-viewer>
      </div>
    </div>
  </div>
  <!-- Container -->
  <div [ngClass]="!FilterViewType || FilterViewType == 'normal' || !openFilter ? 'col-12': 'col-lg-9'">
    <div class="d-flex align-items-center justify-content-between">
      <!-- Titolo + Tasto Filtro -->
      <div class="d-md-flex align-items-center  p-2">
        <div class="mt-3 mt-md-0">
          <div class="d-flex align-items-center ml-3 justify-content-start">
            <button type="button" *ngIf="FilterViewType == 'sidebar'" (click)="openFilter = !openFilter"
              class="btn p-2">
              <i class="fas fa-filter  mr-1 " style="font-size: 18px"
                [ngClass]="openFilter ? 'text-info': 'text-dark'"></i>
            </button>
            <span class="ml-1 text-dark" style="font-size: 25px; text-transform: uppercase; font-weight: 700;">{{title
              ?? '' | translate}}</span>
              <ng-container *ngIf="CrudSettings?.badges?.length">
                <div class="ml-1" *ngFor="let badge of CrudSettings?.badges">
                  <span class="d-flex align-items-center p-2 " *ngIf="ListResponse[badge.field]">
                    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{ badge.nome | translate}}:</h5>
                    <span class="badge badge-pill px-3 font-weight-bold font-14" [ngStyle]="{'background-color': badge.color}">{{ListResponse[badge.field]}}</span>
                  </span>
                </div>

              </ng-container>

          </div>
        </div>
      </div>
      <div class="d-md-flex align-items-center justify-content-end mb-3">
        <button type="button" *ngIf="HasAddButton()" (click)="AddClick()" class="btn btn-cyan p-2">
          <i class="fas fa-plus  font-14 mr-1 text-white"></i>
          <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
        </button>
        <button type="button" *ngIf="CrudSettings && hasExportButtons()" (click)="ExportCsv()" class="btn btn-cyan p-2">
          <i class="fas fa-download  font-14 mr-1 text-white"></i>
          <span class="ml-1 text-white font-weight-bold">Esporta CSV</span>
        </button>
        <button type="button" *ngIf="CrudSettings && hasExportButtons()" (click)="ExportXlsx()" class="btn btn-cyan p-2">
          <i class="fas fa-download  font-14 mr-1 text-white"></i>
          <span class="ml-1 text-white font-weight-bold">Esporta Excel</span>
        </button>
        <ng-container *ngFor="let button of CrudSettings['Buttons']">
          <button type="submit" type="button" [ngClass]="button['class']" [ngbTooltip]="button.placeholder ?? ''"
                  *ngIf=" permission.HasCapacity(button['capacita']) && campoUtility.ButtonShow(button,this)"
                  (click)='customButton(button)'>
            <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1 text-white"></i>
            <span [ngClass]="button['labelClass']"> {{ button['nome'] | translate }} </span>
          </button>
        </ng-container>
        <ng-container *ngIf="hasListActions()">
          <ng-container *ngFor="let button of CrudSettings['AzioniLista']">
            <button type="submit" type="button" [ngClass]="button['class']" [ngbTooltip]="button.placeholder ?? button.tooltip ?? ''"
              *ngIf=" !button.single && campoUtility.ButtonShow(button,Item)" (click)='MassiveButtonClick(button)'>
              <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1 text-white"></i>
              <span [ngClass]="button['labelClass']"> {{ button['nome'] | translate }} </span>
            </button>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Filtri normali -->
    <div class="card" *ngIf=" CrudSettings?.Filters?.length && (!FilterViewType || FilterViewType == 'normal') ">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12">
            <app-field-viewer *ngIf="CrudSettings" [(Campi)]="CrudSettings.Filters" [(Oggetto)]="filtro"
              (OnChange)="Refresh()"></app-field-viewer>
          </div>
        </div>
      </div>
    </div>

      <app-legenda *ngIf="CrudSettings?.Legenda" [legenda]="CrudSettings.Legenda"></app-legenda>
    <!-- Lista -->
    <div class="table-responsive">
      <table class="table table-striped table-hover table-fixed align-middle mb-0 " [ngClass]=" (CrudSettings.noWrap ? 'no-wrap' : '') + (CrudSettings.listClass ?? '') ">
        <thead class="fi">
          <tr *ngIf="dynamicHeader()?.length > 0">
            <th *ngIf="hasListActions()">
              <a href="javascript:void(0)" class="link-header"
                (click)="toggleAll('selected', List)">{{allSelected('selected', List) ? 'Deseleziona tutto' :
                'Seleziona tutto'}}</a>
            </th>
            <ng-container *ngFor="let campo of dynamicHeader()">
              <th scope="col bg-white" (click)="order(campo)" *ngIf="headShow(campo)">{{campo.nome}}</th>
            </ng-container>
            <th scope="col" *ngIf="CrudSettings && (CrudSettings['AzioniLista']?.length || (!CrudSettings['DisableEdit'] && CrudSettings.campi))">Azioni</th>
          </tr>
        </thead>
        <tbody *ngIf="dynamicHeader()?.length > 0 ">
          <tr *ngFor="let item of List " [ngbTooltip]="this.Tooltip(item)">
            <td *ngIf="hasListActions()">
              <input [(ngModel)]="item['selected']" type="checkbox" />
            </td>
            <ng-container *ngFor="let campo of dynamicHeader()">
              <td class="align-middle" [attr.data-label]="campo.nome" (click)='RowClick(item)' *ngIf="headShow(campo)">
                <app-dynamic-list-row (refresh)="Refresh()" [item]="item" [campo]="campo"></app-dynamic-list-row>
              </td>
            </ng-container>

            <td class="align-middle"  *ngIf="CrudSettings && (CrudSettings['AzioniLista']?.length || (!CrudSettings['DisableEdit'] && CrudSettings.campi))">
              <ng-container *ngIf="CrudSettings">
                <ng-container *ngFor="let button of CrudSettings['AzioniLista']">
                  <a href="javascript:void(0)" [ngClass]="button['class']" [ngbTooltip]="button.placeholder ?? button.tooltip ?? ''"
                    *ngIf="campoUtility.ButtonShow(button,item)" (click)='ButtonClick(item, button)'>
                    <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1"></i>
                  </a>
                </ng-container>
              </ng-container>
              <a href="javascript:void(0)" *ngIf="CrudSettings && !CrudSettings['DisableEdit'] && CrudSettings.campi" [ngbTooltip]="'Modifica'" class="link font-16 text-info font-medium mr-2"
                (click)='EditButton(item)'>
                <i-feather name="edit-3" class="feather-sm"></i-feather>
              </a>
              <app-stampa [Stampe]="Stampe(item)" [isIcon]="true" *ngIf="Stampe(item)?.length"></app-stampa>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-center mt-3" *ngIf="totalItems">
      <ngb-pagination
        [collectionSize]="totalItems"
        [(page)]="filtro.page"
        [pageSize]="filtro.size"
        (pageChange)="onPageChange($event)"
        [maxSize]="10"
      >
      </ngb-pagination>
    </div>
  </div>
</div>
